import React, { Component } from 'react';
import   SideNav from "../sidenav/sidenav.js"
import "./build.css"
import  AuthService  from "../api/authentication.js";
import   Ticket  from "./ticket.js"
import   BuildForm  from "./frombuild.js"
import  Moble from "../sidenav/moble.js"
import Test from "./test.js"
import  Image  from "./image.js"
import { ToastContainer, toast } from 'react-toastify';
import qs from 'query-string';
import 'react-toastify/dist/ReactToastify.css';
import Moment from 'react-moment'
import axios from 'axios' 

import {
    Redirect , Link 
  } from 'react-router-dom'
//   https://uvune-events.herokuapp.com
  const endpoint = 'https://uvune-events.herokuapp.com/upload-logo'
const Auth = new AuthService();
class Build extends Component {
  
    constructor(props){
        super(props)
        this.state = {
            loading : false,
            errorend  : false,
            noticeMassage : "",
            noerorrpage :  true,
            sendTo : false,
            allPeople : false,
            closeAllbutton : true,
            typeForm : "",
            payment_id :"",
            totalForm:"",
            showimage:false,
            saveupDate : false,
            selectedFile: null,
            loaded: 0,
            loadingTerms : false,
            image : "",
            files: [],
            terms:false,
            Ifterms : false,
            termsError : false,
            transactions :[],
            transactionsTotal : "",
            termsMS :"",
            file: '',
            imagePreviewUrl: '',
            domain: 'https://uvune-events.herokuapp.com',
            notice :"false",
            hover : false,
            Publish : false,
            formsell : false,
            frinedUrl:""
        }

     
    }

    componentDidMount(){
        this.props.noerorrpage(this.state.noerorrpage)
        const { match: { params } } = this.props;
        // console.log("params.userId",params.id, "params all", params)
               
        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*'  },
        };
        this.setState({
         loading:true
        })
       if(this.props.location.state){

        // console.log("public users param", params.id, this.props.location.state, this.props.location.state.message)
        fetch(this.state.domain+"/payment-item/"+params.id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            this.setState({
               frinedUrl: this.slugify(result.name)
            })
            // console.log("public this.slugify", this.slugify(result.name))
            fetch(this.state.domain+"/transactions?payment_item_id="+params.id, requestOptions)
            .then(res => res.json())
                .then((resulttrans)=>{
                    this.checkform(result)
            // console.log("public users", result)
                        this.setState({
                            datapayment:result,
                            typeForm : result.type,
                            payment_id : result._id,
                            Publish : result.isActive,
                            loading:false,
                            // totalForm: result.form_schema.length,
                            saveupDate : true,
                            transactions: resulttrans.data,
                            transactionsTotal : resulttrans.total,
                            noticeMassage :this.props.location.state.message,
                            notice : this.props.location.state.notice,
                            
                          
                        })
                })
          }).catch( (error) => {
            //  console.log("errro", error);
            this.setState({
                errorend  : true,
                noticeMassage : "Not update",
            })   
         });
       }else{

        fetch(this.state.domain+"/payment-item/"+params.id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            //  console.log("public users", result)
            //  console.log("public this.slugify", this.slugify(result.name))
             this.setState({
                frinedUrl: this.slugify(result.name)
             })
            this.checkform(result)
            fetch(this.state.domain+"/transactions?payment_item_id="+params.id, requestOptions)
            .then(res => res.json())
                .then((resulttrans)=>{
                //    console.log("public trans", resulttrans)
                    this.setState({
                                datapayment:result,
                                typeForm : result.type,
                                payment_id : result._id,
                                transactions: resulttrans.data,
                                transactionsTotal : resulttrans.total,
                                loading:false,
                                saveupDate : true,
                                Publish : result.isActive,
                                // frinedUrl :this.
                                // noticeMassage :this.props.location.state.message,
                                // notice : this.props.location.state.notice,
                            })
                })

            }).catch( (error) => {
                //  console.log("errro", error);
                this.setState({
                    errorend  : true,
                    noticeMassage : "Not update",
                })   
             });  
         

        // console.log("public users fisrt", this.state.page)
         }


       }
    

    getFiles(files){
        this.setState({ 
             Ifterms : true,
             files: files,
             image : files.base64,
            loaded: 0,
         })

        //  console.log("public users fisrt", this.state.image)
      }

      handleCheckBox=(e)=> {
          e.preventDefault
          const dataedit ={ 
            isActive : true
        }
        const requestOptions = {
            method: 'PATCH', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            body: JSON.stringify(dataedit),
        };
        fetch(this.state.domain+"/payment-item/"+ this.state.payment_id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
                //  console.log("organizers============ ", result)
                
                this.setState({
                    Publish : result.isActive,
                    noticeMassage : " update",
                })
                this.timeout()
            }else{
                this.setState({
                    loadingTuition :true,
                }) 
            }
        }).catch( (error) => {
            //  console.log("errro", error);
            this.setState({
                errorend  : true,
                noticeMassage : "Not update",
            })   
         });
      }

      unpublish = (e)=>{
        e.preventDefault
        const dataedit ={ 
          isActive : false
      }
      const requestOptions = {
          method: 'PATCH', 
          headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
          body: JSON.stringify(dataedit),
      };
      fetch(this.state.domain+"/payment-item/"+ this.state.payment_id, requestOptions)
      .then(res => res.json())
      .then((result)=>{
          if(result){
            //    console.log("organizers============ ", result)
              
              this.setState({
                  Publish : result.isActive,
                  noticeMassage : " update",
              })
              this.timeout()
          }else{
              this.setState({
                  loadingTuition :true,
              }) 
          }
      }).catch( (error) => {
          //  console.log("errro", error);
          this.setState({
              errorend  : true,
              noticeMassage : "Not update",
          })   
       });
      }



      checkform=(data)=>{
        //   console.log("data of form_schema", data)
         
        if(data.form_schema)  {
            this.setState({
                formsell : false
             })
            if(data.form_schema.type === "pane"){
                this.setState({
                   totalForm:data.form_schema.elements.length,
                   formsell : true
                })
                // console.log("data of form_schema 2",this.state. formsell, this.state.totalForm)
            }else{
               this.setState({
                   totalForm:"",
                   formsell : false
                })
                // console.log("data of form_schema 2",this.state. formsell, this.state.totalForm)
            }
        }
      }

    //   _handleSubmit(e) {
    //     e.preventDefault();
        
    //     console.log("upload", this.state.imagePreviewUrl )
    //     // TODO: do something with -> this.state.file
    //     // console.log('handle uploading-', this.state.file);
        
    //   }
    
      _handleImageChange(e) {
        e.preventDefault();
    
        let reader = new FileReader();
        let file = e.target.files[0];

        this.setState({
            file: file,
            Ifterms : true
          });

        
    
        // reader.onload = (e) => {
        //     let dataURL = reader.result;
        //     console.log('encoded file: ', dataURL);
          
        //   console.log("file data", this.state.file.name)
        // }
    
        // reader.readAsDataURL(file)

      }
          //   imageUPload=(event)=>{

    //     const reader  = new FileReader();
    //     let file = options.files[0];
    
    //     reader.onprogress = (e) => {
    //         toast(`Uploading...`, { autoClose: 2000, type: toast.TYPE.SUCCESS, position: toast.POSITION.TOP_CENTER });
    //     }
    
    //     reader.onload = (e) => {
    //           let dataURL = reader.result;
    //           //console.log('encoded file: ', dataURL);
    
    //           this.setState({
    //               image: dataURL
    //           })
    //           //toast(`Saving... `, { type: toast.TYPE.SUCCESS, position: toast.POSITION.TOP_CENTER, autoClose: 5000 });
    //         }
    
    //     reader.readAsDataURL(file);

    //   }


     closenotice=(e)=>{
      e.preventDefault()
      this.setState({
        notice :false
      })
  }

    _handleSubmit(e) {
        e.preventDefault();
          this.setState({
              loadingTerms:true
          })
        // console.log("jdtbgkhjsdtg------>",this.state.image)

        const formData = new FormData();
        formData.append('uri', this.state.file)
        //console.log("file upload.....",this.state.file)
        formData.append('terms_upload', true);
        formData.append('payment_item_id', this.state.payment_id);
        const options = {
            method: 'POST',
            headers: { 
                'content-type': 'multipart/form-data',
            'access-control-allow-origin': '*',
            'Authorization': Auth.getToken(), 
            },
            url:this.state.domain+"/upload-logo",
        };
            // console.log("data ----====>",options )
            axios.post(options.url, formData, options.headers)
              .then(res => {
                // console.log(res.statusText)
                //console.log(res)
               this.setState({
                   termsError : true,
                   termsMS : "Upload successful",
                   loadingTerms:false,
                   Ifterms :false
               })
               this.timeout()
              }).catch( (error) => {
                //    console.log("error==------>",error)
                   this.setState({
                     termsError : true,
                     termsMS : "Image to large",
                     loadingTerms:false,
                     Ifterms :false
                   })
                   this.timeout()
             });
  
      }




      uploadme=()=>{
        // console.log("dataURL 00999>>",   this.state.image )
      }

      ShowTerms=(event)=>{
            event.preventDefault
        this.setState({
            terms : true
        })
      }

      closallShow=(event)=>{
        event.preventDefault
        this.setState({
            showimage : false,
            terms :false

        })
      }




    addTopage=(data)=>{
        // console.log("data------>",   data)
        
        const   page = this.state.page
       
          page.push(data)
       this.setState({
           page  ,
           saveupDate : false,
                })
        // console.log("page data----->", page )
    }

    ShowImage=(e)=>{
        e.preventDefault();
      this.setState({
        showimage:true

      })
    }

    slugify(string) {
        const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;'
        const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------'
        const p = new RegExp(a.split('').join('|'), 'g')
    
        return string.toString().toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
            .replace(/&/g, '-and-') // Replace & with 'and'
            .replace(/[^\w\-]+/g, '') // Remove all non-word characters
            .replace(/\-\-+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, '') // Trim - from end of text
    }


// slugify(text)
// {
//   return text.toString().toLowerCase()
//     .replace(/\s+/g, '-')           // Replace spaces with -
//     .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
//     .replace(/\-\-+/g, '-')         // Replace multiple - with single -
//     .replace(/^-+/, '')             // Trim - from start of text
//     .replace(/-+$/, '');            // Trim - from end of text
// }
    


    updatefrom =(e)=>{
        // console.log("data------>",this.state.page )
        const dataedit ={ 
            form_schema    :{ 
                type: "pane",
                elements:  this.state.page
            
            }
        }
        const requestOptions = {
            method: 'PATCH', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            body: JSON.stringify(dataedit),
        };
        fetch(this.state.domain+"/payment-item/"+ this.state.payment_id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
                // console.log("organizers============ ", result)
                
                this.setState({
                    loadingTuition :false,
                    tuitions :result.data,
                    saveupDate:true,
                    errorend  : true,
                    noticeMassage : " update",
                })
                this.timeout()
            }else{
                this.setState({
                    loadingTuition :true,
                    errorend  : true,
                    noticeMassage : "update",
                }) 
                this.timeout()
            }
        }).catch( (error) => {
            //  console.log("errro", error);
            this.setState({
                errorend  : true,
                noticeMassage : "Not update",
            }) 
            this.timeout()
             
         });
    }  

    

    
imageE= (data)=>{
    // console.log("data ------>element build", data.imageerror)
    if(data){
     if(data.imageerror === "true") {
    //    console.log("data ------>element true", data)
          this.timeout()
         }else{
        //    console.log("data ------>element false 2", data)
        }
             
    }else{
    //  console.log("data ------>element false 1", data)
    }
   }

   TicketUpdate=(data )=>{
    // console.log("data------>",this.state.page )
  
    const requestOptions = {
        method: 'PATCH', 
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
        body: JSON.stringify(data),
    };
    fetch(this.state.domain+"/payment-item/"+ this.state.payment_id, requestOptions)
    .then(res => res.json())
    .then((result)=>{
        if(result){
            // console.log("organizers============ ", result)
            
            this.setState({
                loadingTuition :false,
                tuitions :result.data,
                saveupDate:true,
                errorend  : true,
               noticeMassage : "    Update",
            })
        }else{
            this.setState({
                loadingTuition :true,
                errorend  : true,
               noticeMassage : "Update"
            }) 
            this.timeout()
        }
    }).catch( (error) => {
        //  console.log("errro", error);
        this.setState({
            errorend  : true,
            noticeMassage : "Not update",
        }) 
        this.timeout()
         
     });
   }
    
   timeout() {
     setTimeout(function() {
    //    this.setState({ imageshow:false})
      this.setState({
        showimage:false,
        errorend  : false,
        termsError : false
      })
    //    console.log("time out",this.state.showimage);
     }.bind(this), 4000);
   }


    deleteData= (id)=>{
      this.setState({
        saveupDate : false
       }) 
    //   console.log("data dlete",id)
      const  page  = this.state.page
        const fitleredpage  =  page.filter( meassage =>{
          return meassage.id !== id
        })
        // console.log(fitleredpage)
        this.setState({page:fitleredpage})
        const dataedit ={ 
            form_schema    : this.state.page
        }
        const requestOptions = {
            method: 'PATCH', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            body: JSON.stringify(dataedit),
        };
        fetch(this.state.domain+"/payment-item/"+ this.state.payment_id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
                // console.log("organizers============ ", result)
                this.setState({
                    loadingTuition :false,
                    tuitions :result.data,
                    saveupDate : false,
                    errorend  : true,
                    noticeMassage : " delete",
                })
            }else{
                this.setState({
                    loadingTuition :true
                }) 
            }
           this. timeout()
        }).catch( (error) => {
            //  console.log("errro", error);
            this.setState({
                errorend  : true,
                noticeMassage : "Not delete",
            }) 
            this. timeout()
             
         });

    }


    logout = () =>{
   
        this.props.logout()
      }
    render() {
    
        //  console.log("cheking---------tui", this.props.enterme)
       return (
  
          this.state.submitIftrue ? (                 
              <Redirect to={{    pathname: `${'/info'}`  }}/>
         ):
          !this.props.isAuthenticated ? (
            <div className="hero is-bold is-fullheight">
                <div className="level-item">
                <a className="button is-loading is-large is-light">Loading</a>
                </div>
                <div className="level-item">
                <span>Trying to login...</span>
                </div>
            </div>
             )
               :
              <div className="build-fullbody"> 
                 <div className="Activity-moble-nav-body">
                      < Moble  logout={this.logout}/>
                 </div>     
                      <SideNav vanImage={this.props.organizer.image_url} email={this.props.user.email} 
                      logout={this.logout} name={this.props.user.first_name + " " + this.props.user.last_name}
                      organizers404={this.props.organizers404}
                      /> 
            
                     <div className="main main-moble"> 
                            <div className="topright">
                                {
                                    this.state.errorend  ?
                                    <div className="notice-cos-tuition">
                                        {this.state.noticeMassage}
                                    </div> :
                                    <span> </span> 
                                }  
                            </div>
                            {
                                
                              this.state.notice === "true"  ?
                              <div className="notification build-notification-info-c">
                                    <button className="delete" onClick={this.closenotice}></button>
                                    
                                    <i className="fas fa-check has-text-success"></i> <strong>{this.state.noticeMassage}</strong> 
                                </div>
                                :
                                <p></p>

                            }

                        <section className="info-tiles-build-name">
                            <div className="info-tiles-build-name-sub">
                               <p>
                                   {  
                                    this.state.datapayment?
                                     <b>
                                       {this.state.datapayment.name} 
                                     </b>
                                    :
                                    <b></b>
                                   }
                             
                               </p>
                            </div>
                            <div className="info-tiles-build-name-sub-left">
                                {
                                    this.state.datapayment ? 
                                    < Link  to={"/event/edit/"+this.state.datapayment._id} className="button is-small is-rounded">Edit Event</ Link>
                                  :
                                  <a className="button is-small is-rounded">Edit Event</a>
                                }
                             
                                {
                                    this.state.datapayment?
                                    <b>
                                      {
                                         this.state.datapayment.type === "FM"? 
                                         < Link  to={"/form/builder/"+this.state.datapayment._id} className="button is-small is-rounded">Create from</Link>
                                         :
                                         <a className="button is-small is-rounded" title="Disabled  " disabled> Tickets  <i className="fas fa-ticket-alt build-ticket-icon"> </i> </a>

                                       }
                                     </b>
                                     :
                                     <a></a>
                                }
                                {
                                    this.state.Publish === true ?
                                   
                                    <a className="button is-small is-danger is-rounded" onClick={this.unpublish}>  Event Publish </a>
                                    :
                                    <a className="button is-small is-success is-rounded" onClick={this.handleCheckBox}>  Publish Event</a>
                                }
                            
                               
                            </div>

                        </section>
                        <section className="info-tiles">
                            <div className="info-tiles-build-body">
                            <div className="tile is-ancestor has-text-centered">
                                    <div className="tile is-parent">
                                        <article className="tile is-child box">
                                            {
                                                this.state.Publish ?
                                                <p className="title"><i className="fas fa-check has-text-success"></i></p>
                                                :
                                                <p className="title"><i className="fas fa-power-off build-of-icon"></i></p>
                                            }
                                        
                                            <p className="subtitle"><b>Event status</b></p>
                                        </article>
                                    </div>
                                    <div className="tile is-parent">
                                        <article className="tile is-child box">
                                            <p className="title">
                                            {
                                                    this.state.transactionsTotal ? 
                                                        <b>{this.state.transactionsTotal}</b>
                                                     :
                                                       <b>0</b>   
                                                }
                                            </p>
                                        {
                                            this.state.datapayment?
                                            <p className="subtitle">
                                                        {
                                                        this.state.datapayment.type === "FM"? 
                                                          <b>Form sold</b>
                                                            :
                                                          <b>Ticket sold</b>
                                                        }
                                                    </p>
                                                :
                                                <p></p>
                                         }
                                            
                                        </article>
                                    </div>
                                 
                                             
                                            <div className={!this.state.formsell ? 'hidden-build-titick' : 'shown-build-titick tile is-parent'} >
                                                <article className="tile is-child box">
                                                    <p className="title">
                                                        {
                                                            this.state.totalForm ? 
                                                                <b>{this.state.totalForm}</b>
                                                            :
                                                            <b>0</b>   
                                                        }
                                                    </p>
                                                    <p className="subtitle"><i className="fas fa-clipboard-list"></i> <b>Form Input</b></p>
                                                </article>
                                        </div>
                                        <div  className="tile is-parent">
                                            <article className="tile is-child box">
                                                <p className="title"><i className="fas fa-clock has-text-success"></i></p>
                                                <p className="subtitle">
                                                {
                                                    this.state.datapayment?
                                                      <Moment  format="2015-06-17 14:24:36" date={this.state.datapayment.date} />
                                                    :
                                                    <i></i>
                                                }
                                              </p>
                                            </article>
                                        </div>
                                                
                                         
                                                    
                                            
                                  
                                </div>
                            </div>
                               
                            </section>
                    <article className="message is-info message-is-info">
                        <div className="message-header">
                            <p>
                            {
                                    this.state.datapayment?
                                    <b>
                                      {
                                         this.state.datapayment.type === "FM"? 
                                            <b>From Sales</b>
                                         :
                                           <b> Ticket  Sales</b> 

                                       }
                                     </b>
                                     :
                                     <a></a>
                                }
                                
                                
                                </p>
                            {/* <button className="delete" aria-label="delete"></button> */}
                        </div>
                        <div className="message-body">
                         {
                                this.state.transactions ? 
                                <div>
                               {
                                            this.state.transactions === undefined || this.state.transactions === 0 ?
                                                <p></p>
                                                :
                                                <ul className="responsive-table">
                                                            <li className="table-header">
                                                                <div className="col col-1">Name</div>
                                                                <div className="col col-2">Eamil</div>
                                                                <div className="col col-3">Amount </div>
                                                                {/* <div className="col col-4">Status</div> */}
                                                                <div className="col col-4">Date</div>
                                                        </li>
                                                        {
                                                            this.state.transactions.map(trans=>{
                                                            return(

                                                               
                                                                        
                                                                        <li className="table-row" key={trans._id} >
                                                                            <div className="col col-1" data-label="Job Id">{trans.checkoutData.fullname}</div>
                                                                            <div className="col col-2" data-label="Customer Name">{trans.checkoutData.email}</div>
                                                                            <div className="col col-3" data-label="Amount">₦{trans.checkoutData.amount}</div>
                                                                            {/* <div className="col col-4" data-label="Payment Status">{trans.chargeStatus}</div> */}
                                                                            <div className="col col-4" data-label="Payment Status"><Moment  format="YYYY/MM/DD" date={trans.createdAt} /></div>
                                                                        </li>
                                                    
                                                              
                                                              
                                                                )
                                                            })
                                                        } 
                                                    </ul>

                                            }
                                          </div> 
                                          :
                                          <div> </div>
                                        } 
                                    </div>
                                </article>
                         
                      <div>
                    
                        
                   
                   </div>
                 </div>  
              </div>
        )

    }
    
    
    
    
    
    }
    
    export default Build;    


// WEBPACK FOOTER //
// ./src/component/build/build.js